// Ours
import { isDefaultVariant } from './defaultVariant';
import { extractTokenInfo } from './extractTokenInfo';
import { getOrderedTokens } from './getOrderedTokens';
import { id } from './id';
import { merge } from './merge';
import { reduce } from './reduce';
import { rem } from './rem';
import { select } from './select';

export const StyleUtils = {
	reduce,
	rem,
	select,
	merge,
	id,
	isDefaultVariant,
	extractTokenInfo,
	getOrderedTokens,
};
